import React, { useRef } from 'react';
import { Button, Dropdown, ToggleButton, ToggleButtonGroup } from 'react-bootstrap';
import { FaPlus } from 'react-icons/fa';
import { FiEye, FiEyeOff, FiFilter, FiMoreVertical } from 'react-icons/fi';
import { IoIosRefresh } from 'react-icons/io';
import { LIST_VIEW_LABEL } from './agendaDay';
import './AgendaDayList.css';

// Linha do topo da Agenda no celular (até 992 px): a chave "Horários | Calendário" e o menu de opções (⋮), nas duas visões.
// No Calendário, o "Novo agendamento" (onNew) fica aqui, fora do menu; em Horários ele é o botão redondo do canto.
// No menu: Filtros e Atualizar e, só no Calendário, Mostrar/Ocultar legenda e totalizadores (a mesma escolha do computador)
const AgendaViewSwitch = ({
  view, onChange, filter, onFilters, refreshing, onRefresh, onNew, legendShown, onToggleLegend, totalsShown, onToggleTotals,
}) => {
  const menuButton = useRef(null);

  // O painel dos filtros devolve o foco, ao fechar, a quem o tinha ao abrir: o botão do menu, e não o item (já escondido)
  const openFilters = () => {
    menuButton.current?.focus({ preventScroll: true });
    onFilters();
  };

  return (
    <div className='agenda-view-switch'>
      {/* tabIndex -1 vai para o <label> do ToggleButton: só os rádios ficam no Tab (as setas trocam a opção) */}
      <ToggleButtonGroup type='radio' name='agenda-phone-view' value={view} onChange={onChange} aria-label='Visualização da agenda'>
        <ToggleButton id='agenda-phone-view-list' value='list' variant='outline-primary' tabIndex={-1}>{LIST_VIEW_LABEL}</ToggleButton>
        <ToggleButton id='agenda-phone-view-calendar' value='calendar' variant='outline-primary' tabIndex={-1}>Calendário</ToggleButton>
      </ToggleButtonGroup>

      {onNew ? (
        <Button type='button' variant='primary' className='agenda-day-tool' onClick={onNew} aria-label='Novo agendamento' title='Novo agendamento'>
          <FaPlus aria-hidden='true' />
        </Button>
      ) : ''}
      {/* O menu fecha ao tocar num item: atualizando, o ⋮ vira o ícone de Atualizar girando (aria-busy). A bolinha vermelha
          avisa dos filtros aplicados, como no botão Filtros do computador. Pelo teclado, o menu abre no 1º item e o Esc o
          fecha com o foco de volta no botão (react-bootstrap, com o role menu) */}
      <Dropdown align='end' className='agenda-view-menu'>
        <Dropdown.Toggle
          ref={menuButton}
          variant='outline-secondary'
          className={`agenda-day-tool${refreshing ? ' is-spinning' : ''}`}
          aria-label={filter ? 'Opções da agenda (filtros aplicados)' : 'Opções da agenda'}
          aria-haspopup='menu'
          aria-busy={refreshing || undefined}
          title='Opções da agenda'
        >
          {refreshing ? <IoIosRefresh size={20} aria-hidden='true' /> : <FiMoreVertical size={20} aria-hidden='true' />}
          {filter ? <span className='agenda-day-dot' aria-hidden='true' /> : ''}
        </Dropdown.Toggle>
        <Dropdown.Menu role='menu'>
          <Dropdown.Item as='button' type='button' role='menuitem' onClick={openFilters}>
            <FiFilter size={18} aria-hidden='true' />
            Filtros
            {filter ? <><span className='visually-hidden'> (aplicados)</span><span className='agenda-day-dot' aria-hidden='true' /></> : ''}
          </Dropdown.Item>
          <Dropdown.Item as='button' type='button' role='menuitem' onClick={onRefresh}>
            <IoIosRefresh size={18} aria-hidden='true' /> Atualizar
          </Dropdown.Item>
          {view === 'calendar' ? (
            <>
              <Dropdown.Item as='button' type='button' role='menuitem' onClick={onToggleLegend}>
                {legendShown
                  ? <><FiEyeOff size={18} aria-hidden='true' /> Ocultar legenda</>
                  : <><FiEye size={18} aria-hidden='true' /> Mostrar legenda</>}
              </Dropdown.Item>
              <Dropdown.Item as='button' type='button' role='menuitem' onClick={onToggleTotals}>
                {totalsShown
                  ? <><FiEyeOff size={18} aria-hidden='true' /> Ocultar totalizadores</>
                  : <><FiEye size={18} aria-hidden='true' /> Mostrar totalizadores</>}
              </Dropdown.Item>
            </>
          ) : ''}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default AgendaViewSwitch;
